<template>
  <div class="clinic" v-if="clinic && clinic.id">
    <el-tabs v-model="activeName">
      <el-tab-pane label="Main info" name="mainInfo">
        <div class="row">
          <div class="col-md-6">
            <SinglePageConnection :fullItem="clinic" @update="save()" fullItemType="clinic"/>
            <SinglePageNameInfo :fullItem="clinic" type="clinic"/>
            <ClinicAgency/>
            <ClinicLocation v-if="clinic.geo"/>
            <ClinicAccreditations/>
            <ClinicEntities/>
          </div>
          <div class="col-md-6">
            <ClinicRating v-if="clinic.rating"/>
            <ClinicStatistics v-if="clinic.statistics"/>
            <ClinicUrls v-if="clinic.urls"/>
            <ClinicFlags v-if="clinic.id !== 435"/>
            <ClinicReviewTags/>
          </div>
        </div>
      </el-tab-pane>
      <template v-if="domains && Object.keys(domains).length">
        <el-tab-pane label="Short description" name="shortDescription">
          <ClinicDescriptionComponent descriptionType="short_description"/>
        </el-tab-pane>
        <el-tab-pane label="Full description" name="fullDescription">
          <ClinicDescriptionComponent descriptionType="description"/>
        </el-tab-pane>
        <el-tab-pane label="Clinic's texts" name="texts">
          <ClinicTexts/>
        </el-tab-pane>
      </template>
      <el-tab-pane label="Clinic's images" name="images">
        <ClinicLogo @get-clinic-event="getClinicEvent()"/>
        <ClinicsImages @get-clinic-event="getClinicEvent()"/>
      </el-tab-pane>
      <el-tab-pane label="Before / After" name="beforeAfter">
        <OperationResultImages/>
      </el-tab-pane>
      <el-tab-pane label="Prices" name="prices">
        <ClinicPrices/>
      </el-tab-pane>
      <el-tab-pane label="Doctors" name="doctors" lazy>
        <ClinicDoctors/>
      </el-tab-pane>
      <el-tab-pane label="Videos" name="video">
        <ClinicVideos/>
      </el-tab-pane>
      <el-tab-pane label="TOP Clinics" name="topClinics" lazy>
        <ClinicTopPlacements/>
      </el-tab-pane>
      <el-tab-pane label="Widget" name="widget">
        <Widget :clinic="clinic"/>
      </el-tab-pane>
      <div class="row">
        <div class="col-12">
          <base-button type="primary" v-if="isSaveBtnVisible" @click="save()">Update clinic</base-button>
        </div>
      </div>
    </el-tabs>
  </div>
</template>

<script>
import SinglePageConnection from '@/components/SinglePage/SinglePageConnection';
import SinglePageNameInfo from '@/components/SinglePage/SinglePageNameInfo';
import ClinicLocation from '@/components/Clinics/ClinicLocation';
import ClinicAgency from '@/components/Clinics/ClinicAgency';
import ClinicAccreditations from '@/components/Clinics/ClinicAccreditations';
import ClinicRating from '@/components/Clinics/ClinicRating';
import ClinicStatistics from '@/components/Clinics/ClinicStatistics';
import ClinicUrls from '@/components/Clinics/ClinicUrls';
import ClinicDescriptionComponent from '@/components/Clinics/ClinicDescriptionComponent';
import ClinicFlags from '@/components/Clinics/ClinicFlags';
import ClinicsImages from '@/components/Clinics/ClinicsImages';
import ClinicLogo from '@/components/Clinics/ClinicLogo';
import ClinicTopPlacements from '@/components/Clinics/ClinicTopPlacements';
import OperationResultImages from '@/components/Clinics/OperationResultImages/OperationResultImages.vue';
import ClinicPrices from '@/components/Clinics/ClinicPrices/ClinicPrices.vue';
import ClinicDoctors from '@/components/Clinics/ClinicDoctors';
import ClinicTexts from '@/components/Clinics/ClinicTexts';
import ClinicVideos from '@/components/Clinics/video/ClinicVideos';
import Widget from '@/components/Clinics/widget/Widget';
import ClinicEntities from '@/components/Clinics/ClinicEntities';
import ClinicReviewTags from '@/components/Clinics/ClinicReviewTags';
import { mapActions, mapState, mapMutations } from "vuex";

  export default {
    props: ['clinicId'],
    components: {
      SinglePageConnection,
      SinglePageNameInfo,
      ClinicLocation,
      ClinicAgency,
      ClinicAccreditations,
      ClinicRating,
      ClinicStatistics,
      ClinicUrls,
      ClinicDescriptionComponent,
      ClinicFlags,
      ClinicsImages,
      ClinicLogo,
      ClinicTopPlacements,
      OperationResultImages,
      ClinicPrices,
      ClinicDoctors,
      ClinicTexts,
      ClinicVideos,
      Widget,
      ClinicEntities,
      ClinicReviewTags,
    },
    data: () => ({
      activeName: 'mainInfo',
    }),
    computed: {
      ...mapState('clinics', ['clinic']),
      ...mapState('cmsApiCatalogs', ['domains']),
      isSaveBtnVisible() {
        switch (this.activeName) {
          case 'texts':
          case 'video':
          case 'widget':
          case 'beforeAfter':
          case 'prices':
          case 'doctors':
            return false;
        }
        return true;
      },
    },
    created() {
      if (this.$route.query.tab === 'topClinics') this.activeName = 'topClinics';
      this.getClinicEvent();
    },
    beforeDestroy() {
      this.SET_DATA({ type: 'clinic', data: {} });
    },
    methods: {
      ...mapActions('clinics', ['getClinic', 'updateClinic']),
      ...mapMutations('clinics', ['SET_DATA']),
      async getClinicEvent() {
        this.$store.dispatch('setLoader', true);

        await this.getClinic(this.clinicId);
        this.$store.dispatch('setLoader', false);
      },
      save() {
        this.$store.dispatch('setLoader', true);
        const name = {};

        if (this.clinic.name && Object.keys(this.clinic.name).length) {
          Object.keys(this.clinic.name).forEach(lang => {
            if (this.clinic.name[lang]) {
              name[lang] = this.clinic.name[lang];
            }
          });
        }

        return this.updateClinic({ data: { ...this.clinic, name }, clinicId: this.clinicId })
          .then(() => this.$notify({ type: 'success', title: 'Saved' }))
          .catch(() => this.$notify({ type: 'warning', title: 'Save Failed' }))
          .finally(() => this.$store.dispatch('setLoader', false));
      },
    }
  }
</script>
